import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import * as S from './styled';

import { IPersonalPlanCardProps } from './types';

const PersonalPlanCard = ({ img, title, description, isCurrentPlan }: IPersonalPlanCardProps) => {
    const { t } = useTranslation();

    return (
        <S.Card>
            <S.Img src={img} alt="slide" maxWidth={300} mb={16} />

            {isCurrentPlan && (
                <S.CurrentPlan medium color="surface-default" mb={0}>
                    {t('subscription.additionalContentOfferModal.modalA.slider.currentPlan')}
                </S.CurrentPlan>
            )}

            <S.Info>
                <Text medium mb={4} type="h3" color="surface-default">
                    {t(title)}
                </Text>
                <Text mb={0} type="small-text" color="surface-default" medium>
                    {t(description)}
                </Text>
            </S.Info>
        </S.Card>
    );
};

export default PersonalPlanCard;
